/**
 * @generated SignedSource<<eb3baf1edb7407858c84d1547f266fa4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MemberStatusValue = "DELETED" | "INVITED" | "PENDING_INVITATION" | "REGISTERED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SpaceInfoModal_space$data = {
  readonly color: {
    readonly dark: string;
    readonly light: string;
  };
  readonly id: string;
  readonly name: string;
  readonly ownerships: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly explicitOwner: boolean;
        readonly member: {
          readonly id: string;
          readonly status: {
            readonly value: MemberStatusValue;
          } | null;
        };
        readonly " $fragmentSpreads": FragmentRefs<"Owner_ownership">;
      } | null;
    }>;
  };
  readonly " $fragmentType": "SpaceInfoModal_space";
};
export type SpaceInfoModal_space$key = {
  readonly " $data"?: SpaceInfoModal_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceInfoModal_space">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpaceInfoModal_space",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Color",
      "kind": "LinkedField",
      "name": "color",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "light",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dark",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OwnershipConnection",
      "kind": "LinkedField",
      "name": "ownerships",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OwnershipEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Ownership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Owner_ownership"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "explicitOwner",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Member",
                  "kind": "LinkedField",
                  "name": "member",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "status",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Space",
  "abstractKey": null
};
})();

(node as any).hash = "b450867818f13af5e39a13fd4dc51353";

export default node;
